import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { SESSIONS } from "./ReservationForm";

const DAYS = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];
const TONE = { ogle: "bg-amber-100 text-amber-800", aksam: "bg-rose-100 text-rose-800", tam_gun: "bg-violet-100 text-violet-800" };
const pad = (n) => String(n).padStart(2, "0");

export const ReservationCalendar = ({ rows, onOpen, onNew }) => {
  const now = new Date();
  const [ym, setYm] = useState({ y: now.getFullYear(), m: now.getMonth() });
  const first = new Date(ym.y, ym.m, 1), daysIn = new Date(ym.y, ym.m + 1, 0).getDate();
  const lead = (first.getDay() + 6) % 7;
  const cells = [...Array(lead).fill(null), ...Array.from({ length: daysIn }, (_, i) => i + 1)];
  const byDay = {};
  rows.filter((r) => r.status !== "cancelled").forEach((r) => { (byDay[r.event_date] = byDay[r.event_date] || []).push(r); });
  const shift = (d) => setYm(({ y, m }) => { const n = new Date(y, m + d, 1); return { y: n.getFullYear(), m: n.getMonth() }; });
  const today = now.toISOString().slice(0, 10);
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-rose-100 p-4" data-testid="rsv-calendar">
      <div className="flex items-center justify-between mb-4">
        <button onClick={() => shift(-1)} className="p-2 rounded-xl hover:bg-rose-50" data-testid="cal-prev"><ChevronLeft className="w-4 h-4" /></button>
        <div className="font-serif text-lg text-rose-900" data-testid="cal-title">{first.toLocaleDateString("tr-TR", { month: "long", year: "numeric" })}</div>
        <button onClick={() => shift(1)} className="p-2 rounded-xl hover:bg-rose-50" data-testid="cal-next"><ChevronRight className="w-4 h-4" /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-[11px] uppercase text-slate-400 text-center mb-1">{DAYS.map((d) => <div key={d}>{d}</div>)}</div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (!d) return <div key={i} />;
          const iso = `${ym.y}-${pad(ym.m + 1)}-${pad(d)}`, list = byDay[iso] || [];
          return (
            <div key={i} className={`group min-h-[84px] rounded-xl border p-1.5 text-left transition-colors ${list.length ? "border-rose-200 bg-rose-50/40" : "border-slate-100 hover:bg-rose-50/30"} ${iso === today ? "ring-2 ring-rose-300" : ""}`} data-testid={`cal-day-${iso}`}>
              <div className="flex items-center justify-between"><span className="text-xs font-medium text-slate-600">{d}</span>
                <button onClick={() => onNew(iso)} className="opacity-0 group-hover:opacity-100 text-rose-500 transition-opacity" data-testid={`cal-add-${iso}`}><Plus className="w-3.5 h-3.5" /></button></div>
              <div className="space-y-1 mt-1">{list.map((r) => (
                <button key={r.id} onClick={() => onOpen(r.id)} className={`w-full truncate text-[10px] px-1.5 py-0.5 rounded-md text-left ${TONE[r.session] || TONE.aksam}`} data-testid={`cal-rsv-${r.id}`}>
                  {SESSIONS[r.session]?.slice(0, 2)} · {r.couple_name}
                </button>
              ))}</div>
            </div>
          );
        })}
      </div>
      <div className="flex gap-3 mt-3 text-[11px] text-slate-500">{Object.entries(SESSIONS).map(([k, v]) => <span key={k} className="inline-flex items-center gap-1"><span className={`w-2.5 h-2.5 rounded ${TONE[k]}`} />{v}</span>)}</div>
    </div>
  );
};
